import InitializeLayout from '@js/layout';

InitializeLayout();
